/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskChangeManagementType from '@jira/spa-apps__project-settings-service-desk-change-management-settings/src/ServiceDeskChangeManagementSettingsPage.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskChangeManagement: LazyComponent<
	() => React.JSX.Element
> = lazyForPaint<typeof ProjectSettingsServiceDeskChangeManagementType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-service-desk-change-management", jiraSpaEntry: "async-project-settings-service-desk-change-management" */ '@jira/spa-apps__project-settings-service-desk-change-management-settings/src/ServiceDeskChangeManagementSettingsPage.tsx'
		),
	),
);

const AsyncProjectSettingsServiceDeskChangeManagement = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskChangeManagement}
		pageId="project-settings-change-management"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskChangeManagement;
